/** White-label product strings (visual only; internal names unchanged). */
export const BRAND_NAME = "JARVIS";
export const BRAND_CONTROL_CENTER = "JARVIS Control Center";
export const BRAND_OS = "JARVIS OS";
export const SKILLS_REGISTRY_DISPLAY_NAME = "JARVIS Agents";

/** Hide sidebar/help links to vendor documentation (JARVIS white-label). */
export const PUBLIC_VENDOR_DOCS_ENABLED = false;
